// app/javascript/modules/admissoes/beneficios.js
export function initBeneficios($form, h) {
  const { hide, show, uncheckByName, clearValue } = h
  const ns = ".admissaoBeneficios"

  // --- helpers locais (não dependem do crud/form_controller) ---
  function $wrap(cls) { return $form.find(cls) }

  function setRequired($el, on) {
    if (!$el || $el.length === 0) return
    $el.prop("required", !!on)
    if (on) $el.attr("aria-required", "true")
    else $el.removeAttr("aria-required")
  }

  function setEnabled($el, on, { clearOnDisable = true } = {}) {
    if (!$el || $el.length === 0) return
    // disabled resolve 90% dos casos; readonly ajuda quando há máscaras
    $el.prop("disabled", !on)
    $el.prop("readonly", !on)
    if (!on && clearOnDisable) $el.val("")
  }

  function hideWrapAndDisable($wrapper, $inputs, { clear = true } = {}) {
    hide($wrapper)
    setEnabled($inputs, false, { clearOnDisable: clear })
    setRequired($inputs, false)
  }

  function showWrapAndEnable($wrapper, $inputs, { required = false } = {}) {
    show($wrapper)
    setEnabled($inputs, true, { clearOnDisable: false })
    setRequired($inputs, required)
  }

  // Esconde wrapper e remove required dos inputs internos, salvando estado via data-conditional-required
  function hideWrapOnly($wrapper) {
    hide($wrapper)
    $wrapper.find("input, select, textarea").each(function() {
      const $el = $form.constructor(this) // usa o jQuery já disponível via $form (evita dependência do $ global)
      if ($el.prop("required")) {
        $el.attr("data-conditional-required", "true")
      }
      $el.prop("required", false).removeAttr("aria-required")
    })
  }

  // Mostra wrapper e restaura required nos inputs que tinham data-conditional-required
  function showWrapOnly($wrapper) {
    show($wrapper)
    $wrapper.find("[data-conditional-required='true']").prop("required", true).attr("aria-required", "true")
  }

  // --- máscara dinâmica (money <-> percent) ---
  function applyMaskKind($input, kind /* 'money'|'percent' */) {
    if (!$input || $input.length === 0) return
    $input.attr("data-crud--mask-kind-value", kind)
    // força reformatar sem depender de reconnect
    $input.trigger("blur")
  }

  // inputs por id (como você já usa em clearValue)
  function $inputById(id) { return $form.find(id) }

  function syncPossuiValeTransporte() {
    const val = $form.find('input[name="params[possui_vale_transporte]"]:checked').val()

    const $wBilhete = $wrap(".possui_cartao_bilhete_unico")
    const $wNumCartao = $wrap(".params_numero_cartao_vale_transporte")
    const $wDesvinc = $wrap(".params_esta_desvinculado_da_empresa_anterior")
    const $wContato = $wrap(".params_entrar_em_contato_antiga_empresa")

    const $numCartao = $inputById("#params_numero_cartao_vale_transporte")

    if (val === "Sim") {
      showWrapOnly($wBilhete)
      showWrapOnly($wDesvinc)

      // ✅ não decide aqui — deixa a regra do bilhete controlar o campo do número
      syncPossuiCartaoBilheteUnico()
    } else {
      hideWrapOnly($wBilhete)
      hideWrapAndDisable($wNumCartao, $numCartao)
      hideWrapOnly($wDesvinc)
      hideWrapOnly($wContato)

      uncheckByName("params[possui_cartao_bilhete_unico]")
      clearValue("#params_numero_cartao_vale_transporte")
      uncheckByName("params[esta_desvinculado_da_empresa_anterior]")
    }
  }

  function syncPossuiCartaoBilheteUnico() {
    const val = $form.find('input[name="params[possui_cartao_bilhete_unico]"]:checked').val()

    const $wNumCartao = $wrap(".params_numero_cartao_vale_transporte")
    const $wDesvinc = $wrap(".params_esta_desvinculado_da_empresa_anterior")
    const $wContato = $wrap(".params_entrar_em_contato_antiga_empresa")

    const $numCartao = $inputById("#params_numero_cartao_vale_transporte")

    if (val === "Sim") {
      // aqui geralmente passa a fazer sentido exigir o número (se essa for a regra)
      showWrapAndEnable($wNumCartao, $numCartao, { required: true })
      showWrapOnly($wDesvinc)
    } else {
      hideWrapAndDisable($wNumCartao, $numCartao)
      hideWrapOnly($wDesvinc)
      hideWrapOnly($wContato)

      uncheckByName("params[esta_desvinculado_da_empresa_anterior]")
      clearValue("#params_numero_cartao_vale_transporte")
    }
  }

  function syncEstaDesvinculadoEmpresaAnterior() {
    const val = $form.find('input[name="params[esta_desvinculado_da_empresa_anterior]"]:checked').val()
    const $wContato = $wrap(".params_entrar_em_contato_antiga_empresa")

    if (val === "Não") showWrapOnly($wContato)
    else hideWrapOnly($wContato)
  }

  function syncAssistenciaMedica() {
    const val = $form.find('input[name="params[assistencia_medica]"]:checked').val()

    const $wPart = $wrap(".params_participacao_empregado")
    const $wPerc = $wrap(".params_participacao_empregado_percentual")
    const $perc = $inputById("#params_participacao_empregado_percentual")

    if (val === "Sim") {
      // Mostra só o rádio de participação.
      // O percentual SÓ deve aparecer quando participacao_empregado == "Sim".
      show($wPart)
      hideWrapAndDisable($wPerc, $perc) // ✅ garante que não abre “sozinho” na 1ª vez
      clearValue("#params_participacao_empregado_percentual")
    } else {
      hide($wPart)
      hideWrapAndDisable($wPerc, $perc)
      uncheckByName("params[participacao_empregado]")
      clearValue("#params_participacao_empregado_percentual")
    }
  }

  function syncParticipacaoEmpregado() {
    const val = $form.find('input[name="params[participacao_empregado]"]:checked').val()

    const $wPerc = $wrap(".params_participacao_empregado_percentual")
    const $perc = $inputById("#params_participacao_empregado_percentual")

    // ✅ Se não tem escolha ainda, NÃO mostra percentual.
    if (!val) {
      hideWrapAndDisable($wPerc, $perc)
      clearValue("#params_participacao_empregado_percentual")
      return
    }

    if (val === "Sim") {
      showWrapAndEnable($wPerc, $perc, { required: true })
      applyMaskKind($perc, "percent")
    } else {
      hideWrapAndDisable($wPerc, $perc)
      clearValue("#params_participacao_empregado_percentual")
    }
  }

  function syncTicketAlimentacao() {
    const val = $form.find('input[name="params[ticket_alimentacao]"]:checked').val()

    const $wValor = $wrap(".params_valor_ticket_alimentacao")
    const $valor = $inputById("#params_valor_ticket_alimentacao")

    if (val === "Diário" || val === "Mensal") {
      showWrapAndEnable($wValor, $valor, { required: true })
    } else {
      hideWrapAndDisable($wValor, $valor)
      clearValue("#params_valor_ticket_alimentacao")
    }
  }

  function syncTicketRefeicao() {
    const val = $form.find('input[name="params[ticket_refeicao]"]:checked').val()

    const $wValor = $wrap(".params_valor_ticket_refeicao")
    const $valor = $inputById("#params_valor_ticket_refeicao")

    if (val === "Diário" || val === "Mensal") {
      showWrapAndEnable($wValor, $valor, { required: true })
    } else {
      hideWrapAndDisable($wValor, $valor)
      clearValue("#params_valor_ticket_refeicao")
    }
  }

  function syncDescontaEmContracheque() {
    const val = $form.find('input[name="params[desconta_em_contracheque]"]:checked').val()

    const $wTipo = $wrap(".params_tipo_desconto_contracheque")
    const $wValor = $wrap(".params_desconto_em_contracheque")
    const $valor = $inputById("#params_desconto_em_contracheque")

    if (val === "Sim") {
      show($wTipo)
      // tipo passa a ser required; como é check_box_multiplo, required no input não ajuda muito,
      // mas manter o wrapper visível e limpar quando desliga já resolve validação de “campo escondido”.
    } else {
      hide($wTipo)
      uncheckByName("params[tipo_desconto_contracheque]")

      hideWrapAndDisable($wValor, $valor)
      clearValue("#params_desconto_em_contracheque")
      // volta para money por padrão (evita ficar “percent” na próxima vez)
      applyMaskKind($valor, "money")
    }
  }

  function syncTipoDescontoContracheque() {
    const val = $form.find('input[name="params[tipo_desconto_contracheque]"]:checked').val()

    const $wValor = $wrap(".params_desconto_em_contracheque")
    const $valor = $inputById("#params_desconto_em_contracheque")

    if (val === "Valor (R$)") {
      showWrapAndEnable($wValor, $valor, { required: true })
      applyMaskKind($valor, "money")
    } else if (val === "Percentual (%)") {
      showWrapAndEnable($wValor, $valor, { required: true })
      applyMaskKind($valor, "percent")
    } else {
      hideWrapAndDisable($wValor, $valor)
      clearValue("#params_desconto_em_contracheque")
    }
  }

  function apply() {
    syncPossuiValeTransporte()
    syncPossuiCartaoBilheteUnico()
    syncEstaDesvinculadoEmpresaAnterior()
    syncAssistenciaMedica()
    syncParticipacaoEmpregado()
    syncTicketAlimentacao()
    syncTicketRefeicao()
    syncDescontaEmContracheque()
    syncTipoDescontoContracheque()
  }

  $form.off(ns)
  $form.on(`change${ns}`, 'input[name="params[possui_vale_transporte]"]', syncPossuiValeTransporte)
  $form.on(`change${ns}`, 'input[name="params[possui_cartao_bilhete_unico]"]', syncPossuiCartaoBilheteUnico)
  $form.on(`change${ns}`, 'input[name="params[esta_desvinculado_da_empresa_anterior]"]', syncEstaDesvinculadoEmpresaAnterior)
  $form.on(`change${ns}`, 'input[name="params[assistencia_medica]"]', syncAssistenciaMedica)
  $form.on(`change${ns}`, 'input[name="params[participacao_empregado]"]', syncParticipacaoEmpregado)
  $form.on(`change${ns}`, 'input[name="params[ticket_alimentacao]"]', syncTicketAlimentacao)
  $form.on(`change${ns}`, 'input[name="params[ticket_refeicao]"]', syncTicketRefeicao)
  $form.on(`change${ns}`, 'input[name="params[desconta_em_contracheque]"]', syncDescontaEmContracheque)
  $form.on(`change${ns}`, 'input[name="params[tipo_desconto_contracheque]"]', syncTipoDescontoContracheque)

  return { apply, destroy() { $form.off(ns) } }
}
